enum SessionStorageType {
    RedirectUri = 'redirect_uri',
}

export default SessionStorageType;
